import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-h5" }

import { pickBy, isEqual, isEmpty } from 'lodash'
import { Ref, ref } from 'vue'
import CitizenForm from './CitizenForm.vue'
import CitizenDependentsTab from './CitizenDependentsTab.vue'
import CitizenGuardiansTab from './CitizenGuardiansTab.vue'
import CitizenCardsTab from './CitizenCardsTab.vue'
import { CardHeader } from '../../../../components'
import { createCtx, handleError, callSuccessToast, useWatcherSavedRef } from '../../../../helpers'
import {
  UpdateCitizenOpts,
  CitizensService,
  Citizen,
  CitizenDocument,
  IdentityCardsService,
  getCitizenDocumentInfo,
  AppAuthService,
  MunicipalEntitiesService,
  AddCitizenDocument,
  Id,
  ConsumptionRatesService,
  ConsumptionStandardsService,
  CardIssuePointsService,
  MunicipalEntity,
  AddressSuggesterService,
} from '@prodcard/core'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizensEditPage',
  props: {
    identityCardsService: {},
    citizensService: {},
    municipalEntitiesService: {},
    cardIssuePointsService: {},
    authService: {},
    consumptionRatesService: {},
    consumptionStandardsService: {},
    addressSuggesterService: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;



const citizen = ref<Citizen | undefined>(undefined)
const citizenDocs: Ref<CitizenDocument[]> = ref([])
const loading = ref(false)
const citizenLoading = ref(true)
const disabled = ref(false)
const tab = useWatcherSavedRef('CitizenEditPageTab', 'citizen')
const municipalEntity = ref<MunicipalEntity>()
const router = useRouter()

handleError(async () => {
  citizen.value = await props.citizensService.findById(createCtx(), props.id)
  citizenDocs.value = await props.citizensService.findCitizenDocuments(createCtx(), props.id)
  if (citizen.value?.municipalEntityId) {
    const me = await props.municipalEntitiesService.findById(createCtx(), citizen.value.municipalEntityId)
    municipalEntity.value = me
  }
}, citizenLoading)

const updateCitizen = (updateCitizenOpts: UpdateCitizenOpts) => {
  handleError(async () => {
    if (!citizen.value) return

    const fullCitizen = {
      ...citizen.value,
      documents: citizenDocs.value,
    }

    const opts: UpdateCitizenOpts = pickBy(updateCitizenOpts, (val, key) => {
      if (!val && !fullCitizen?.[key as keyof typeof fullCitizen]) return false
      if (!isEqual(fullCitizen?.[key as keyof typeof fullCitizen], val)) return true
      return !val
    })

    if (opts.documents) {
      opts.documents = opts.documents.map(doc => {
        return pickBy(doc, (val, key) => {
          return !['createdAt', 'id', 'citizenId'].includes(key)
        }) as AddCitizenDocument
      })
    }

    if (isEmpty(opts)) return
    await props.citizensService.update(createCtx(), citizen.value.id, opts)
    callSuccessToast('Данные гражданина обновлены')
    router?.back()
  }, loading)
}

const deleteCitizen = (id: Id) => {
  handleError(async () => {
    await props.citizensService.delete(createCtx(), id)
    callSuccessToast('Гражданин удален')
    router?.back()
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'citizen')),
              variant: _unref(tab) === 'citizen' ? 'flat' : 'tonal',
              size: "large",
              ripple: false
            }, {
              default: _withCtx(() => [
                _createTextVNode("Гражданин")
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'dependents')),
              variant: _unref(tab) === 'dependents' ? 'flat' : 'tonal',
              size: "large",
              ripple: false
            }, {
              default: _withCtx(() => [
                _createTextVNode("Иждивенцы")
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'guardians')),
              variant: _unref(tab) === 'guardians' ? 'flat' : 'tonal',
              size: "large",
              ripple: false
            }, {
              default: _withCtx(() => [
                _createTextVNode("Опекуны")
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (tab.value = 'cards')),
              variant: _unref(tab) === 'cards' ? 'flat' : 'tonal',
              size: "large",
              ripple: false
            }, {
              default: _withCtx(() => [
                _createTextVNode("Карты")
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardHeader), null, {
                      default: _withCtx(() => [
                        (citizen.value && !citizenLoading.value)
                          ? (_openBlock(), _createBlock(_component_v_list, {
                              key: 0,
                              class: "pa-0 bg-transparent"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  title: citizen.value.name + ' ' + citizen.value.surname
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_avatar, {
                                      color: "primary",
                                      size: "large"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_1, _toDisplayString(citizen.value.name[0] + citizen.value.surname[0]), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["title"])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                              key: 1,
                              width: "350",
                              class: "bg-transparent",
                              type: "list-item-avatar-two-line"
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (citizen.value && !citizenLoading.value)
                  ? (_openBlock(), _createBlock(_component_v_card_text, {
                      key: 0,
                      class: "pa-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window, {
                          modelValue: _unref(tab),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(tab) ? (tab).value = $event : null)),
                          class: "pt-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { value: "citizen" }, {
                              default: _withCtx(() => [
                                _createVNode(CitizenForm, {
                                  "address-suggester-service": _ctx.addressSuggesterService,
                                  "auth-service": _ctx.authService,
                                  citizen: citizen.value,
                                  documents: citizenDocs.value,
                                  loading: loading.value,
                                  disabled: citizenLoading.value || disabled.value,
                                  "municipal-entities-service": _ctx.municipalEntitiesService,
                                  onOnSubmit: updateCitizen,
                                  onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router?.back())),
                                  onDelete: deleteCitizen
                                }, null, 8, ["address-suggester-service", "auth-service", "citizen", "documents", "loading", "disabled", "municipal-entities-service"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: "dependents" }, {
                              default: _withCtx(() => [
                                _createVNode(CitizenDependentsTab, {
                                  "citizens-service": _ctx.citizensService,
                                  citizen: citizen.value
                                }, null, 8, ["citizens-service", "citizen"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: "guardians" }, {
                              default: _withCtx(() => [
                                _createVNode(CitizenGuardiansTab, {
                                  "citizens-service": _ctx.citizensService,
                                  citizen: citizen.value
                                }, null, 8, ["citizens-service", "citizen"])
                              ]),
                              _: 1
                            }),
                            (_ctx.authService.authorizedUser.value)
                              ? (_openBlock(), _createBlock(_component_v_window_item, {
                                  key: 0,
                                  value: "cards"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(CitizenCardsTab, {
                                      "card-issue-points-service": _ctx.cardIssuePointsService,
                                      "municipal-entities-service": _ctx.municipalEntitiesService,
                                      "identity-cards-service": _ctx.identityCardsService,
                                      citizen: citizen.value,
                                      "current-user": _ctx.authService.authorizedUser.value,
                                      "citizen-document-info": _unref(getCitizenDocumentInfo)(citizenDocs.value),
                                      "municipal-entity": municipalEntity.value,
                                      "consumption-rates-service": _ctx.consumptionRatesService,
                                      "consumption-standards-service": _ctx.consumptionStandardsService
                                    }, null, 8, ["card-issue-points-service", "municipal-entities-service", "identity-cards-service", "citizen", "current-user", "citizen-document-info", "municipal-entity", "consumption-rates-service", "consumption-standards-service"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_window_item, { value: "logs" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" logs ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                      key: 1,
                      type: "heading@8, actions"
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})